<template>
  <div class="secondary-theme light-theme c-fluid" id="team">
    <div class="row">
      <div class="col-sm-12 col-lg-8 px-0 row">
        <div class="col-3 title-line yellow my-auto"></div>
        <div class="col-4 title-text my-auto text-center">O U R &nbsp; T E A M</div>
        <div class="col-5 title-line yellow my-auto"></div>
      </div>
    </div>
    <div class="t-content">
      <h1 class="quote">meet some of our team members making it happen</h1>
      <div class="row justify-content-between">
        <div class="t-col mx-auto text-center" v-for="(person, index) in list" :key="index">
          <img :src="person.img" class="team">
          <div class="t-name text-right">
            <span class="mb-1 name">{{person.title}}</span>
            <p class="mb-0 mt-2">{{person.role}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import data from "./../data/data";
export default {
  name: "Team",
  data() {
    return {
      list: data.team
    };
  }
};
</script>

<style scoped>
.t-content {
  margin: 0 1rem 0 3rem;
}
.t-col {
  -webkit-box-flex: 0;
}
.team {
  width: 280px;
}
.t-name {
  background-color: black;
  color: white;
  position: relative;
  bottom: 25px;
  left: 25px;
  display: inline-block;
}
@media screen and (max-width: 330px) {
  .t-name {
    width: 200px;
    padding: 0.7rem;
    font-size: 0.85rem;
  }
  .team {
    width: 230px !important;
  }
}
@media screen and (min-width: 331px) and (max-width: 1300px) {
  .t-name {
    width: 250px;
    padding: 0.7rem;
    font-size: 0.85rem;
  }
}

@media screen and (min-width: 1301px) {
  .t-name {
    width: 290px;
    padding: 1rem;
  }
}

@media screen and (max-width: 600px) {
  .t-col {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
@media screen and (min-width: 601px) and (max-width: 1100px) {
  .t-col {
    flex: 0 0 50%;
    max-width: 50%;
  }
}

@media screen and (min-width: 1101px) and (max-width: 1400px) {
  .t-col {
    flex: 0 0 33.3%;
    max-width: 33.3%;
  }
}

@media screen and (min-width: 1401px) {
  .t-col {
    flex: 0 0 25%;
    max-width: 25%;
  }
}

.quote {
  margin: 4rem 0 !important;
}
.name {
  border-bottom: 1px solid #ffc001;
}
</style>



// WEBPACK FOOTER //
// src/components/Team.vue